export default "__VITE_ASSET__Dk4RyFQG__"